// src/components/portal/AddNamesButton.js — the "Add Names" action: a plus
// in a circle next to the label in small caps, rather than a plain
// "+ Add Names" string.
//
// Two variants:
// - "button" (default) — small pill, used in the Your Pipeline section
//   header (PortalMandateDetail).
// - "feature" — mid-size, no button box, plain text+icon. Used right-aligned
//   in the mandate tile's open space (PortalMandates) so it reads as this
//   card's primary call to action (keeping names/follow-ups on the
//   partner's radar) rather than a minor secondary control. Centered read
//   as an orphaned, unclear element floating in the card's empty space.
import { useState } from 'react'
import { Link } from 'react-router-dom'

export default function AddNamesButton({ to, onClick, className = 'btn btn-secondary btn-sm', style, variant = 'button' }) {
  const [hover, setHover] = useState(false)

  if (variant === 'feature') {
    return (
      <Link
        to={to}
        onClick={onClick}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        style={{
          display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none',
          color: hover ? 'var(--accent)' : 'var(--text-primary)',
          transition: 'color 0.15s ease',
          ...style,
        }}
      >
        <span style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          width: 28, height: 28, borderRadius: '50%',
          border: '2px solid currentColor', flexShrink: 0,
          fontSize: 16, lineHeight: 1,
        }}>
          +
        </span>
        <span style={{ fontSize: 13, fontWeight: 700 }}>
          Add Names
        </span>
      </Link>
    )
  }

  return (
    <Link to={to} onClick={onClick} className={className} style={style}>
      <span style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        width: 16, height: 16, borderRadius: '50%',
        border: '1.5px solid currentColor', flexShrink: 0,
        fontSize: 11, lineHeight: 1,
      }}>
        +
      </span>
      <span style={{ fontSize: 11, fontWeight: 600 }}>
        Add Names
      </span>
    </Link>
  )
}
